/** Which layout the Home tab uses, from the window width (phone / tablet portrait / wide). */

import { useEffect, useState } from "react";

type ViewportTier = 'phone' | 'tablet-portrait' | 'wide';

function getViewportTier(): ViewportTier {
  const w = window.innerWidth;
  if (w < 768) return 'phone';
  if (w < 1024) return 'tablet-portrait';
  return 'wide';
}

export function useViewportTier(): ViewportTier {
  const [tier, setTier] = useState<ViewportTier>(getViewportTier);
  useEffect(() => {
    const handler = () => setTier(getViewportTier());
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return tier;
}

// An iPad in landscape is often 1024px+ wide — the same 'wide' tier as a real desktop
// monitor — but it's a touch device with no room to spare the way a desktop has, so
// viewport width alone can't tell "iPad landscape" and "desktop" apart. Touch capability
// doesn't change at runtime, so this only needs computing once.
export const isTouchDevice = typeof window !== 'undefined' &&
  (('ontouchstart' in window) || (navigator.maxTouchPoints ?? 0) > 0);
